<div class="modal-header">
  <h4 class="modal-title">{{ pageTitle }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    [disabled]="loading"
    (click)="close()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body factory_admin">
  <div *ngIf="forShippingOrders.length">
    <h6 class="shippable">Shippable Orders ({{ forShippingOrders.length }})</h6>
    <div class="list-table">
      <table class="shippable table table-stripped">
        <thead>
          <tr>
            <th>Order Date</th>
            <th>Order ID</th>
            <th>Order #</th>
            <th *ngIf="order?.items?.length > 0"> # of Items </th>
            <th class="text-right">Total</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let order of forShippingOrders">
            <td>{{ order.orderDate | date: 'mediumDate' }}</td>
            <td>{{ order.orderId }}</td>
            <td>{{ order.orderNumber }}</td>
            <td *ngIf="order?.items?.length > 0" class="text-right">
              {{ order?.items?.length ?? 0 }}
            </td>
            <td class="text-right">{{ order.orderTotal | currency: '' }}</td>
            <td>
              <span
                class="shipping text-info"
                *ngIf="order.shippingStatus === shippingStatus.SHIPPING"
              >
                Shipping <i class="fas fa-spinner fa-spin"></i>
              </span>
              <span
                class="shipping text-danger"
                *ngIf="order.shippingStatus === shippingStatus.FAILED"
              >
                FAILED
                <span *ngIf="order.shippingError">
                  [{{ order.shippingError }}]
                </span>
              </span>
              <span
                class="shipping text-success"
                *ngIf="order.shippingStatus === shippingStatus.SHIPPED"
              >
                SHIPPED
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <h6 class="text-danger" *ngIf="!forShippingOrders.length">
    No orders can be shipped
  </h6>
  <hr />
  <div class="action text-right mb-3">
    <button
      class="btn btn-default mr-1"
      type="button"
      [disabled]="loading"
      (click)="close()"
    >
      Close
    </button>
    <button
      class="btn btn-primary"
      type="button"
      (click)="shipOrders()"
      [disabled]="loading || !forShippingOrders.length"
      [ngClass]="{
        'kt-spinner kt-spinner--left kt-spinner--md kt-spinner--light': loading,
      }"
    >
      <span *ngIf="!loading"> Confirm and Ship Orders </span>
      <span *ngIf="loading"> Shipping orders, please wait...</span>
    </button>
  </div>
  <hr />
  <div *ngIf="cantBeShippedOrders.length">
    <h6 class="non-shippable">These orders can't be shipped due to:</h6>
    <div class="list-table">
      <table class="shippable table table-stripped">
        <thead>
          <tr>
            <th>Order Date</th>
            <th>Order ID</th>
            <th>Order #</th>
            <th *ngIf="order?.items?.length > 0"> # of Items </th>
            <th class="text-right">Total</th>
            <th class="text-right">Error(s)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let order of cantBeShippedOrders">
            <td>{{ order.orderDate | date: 'mediumDate' }}</td>
            <td>{{ order.orderId }}</td>
            <td>{{ order.orderNumber }}</td>
            <td *ngIf="order?.items?.length > 0">
              {{ order?.items?.length ?? 0 }}
            </td>
            <td class="text-right">{{ order.orderTotal | currency: '' }}</td>
            <td class="text-right text-bold text-warning">
              {{ order.errors.join('\n') }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="modal-footer"></div>
